// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationPowerSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.563 3.227c.135-.43.56-.727 1.041-.727h7.222c.782 0 1.307.747.994 1.415l-2.636 5.61h2.056c.88 0 1.394.925.885 1.594l-7.57 9.952c-.631.83-2.035.369-1.967-.646l.378-5.63h-2.58c-.723 0-1.244-.647-1.041-1.293z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationPowerSolid;
